var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (articles, featuredArticles, resize, undefined) {
if ( featuredArticles.length)
{
buf.push("<div id=\"home-featured-articles-section\" data-context=\"featured articles\"><h2 class=\"home-featured-header\"><span class=\"home-featured-header__title\">Artsy Editorial</span><div class=\"home-browse-all-right\"><a href=\"/articles\">Explore Editorial</a></div></h2><ul id=\"home-featured-articles\" class=\"home-featured-list\">");
articles = featuredArticles.take(7)
// iterate articles
;(function(){
  var $$obj = articles;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var article = $$obj[i];

buf.push("<li class=\"home-featured-article-link\"><a" + (jade.attr("href", article.href(), true, true)) + "><div" + (jade.attr("style", "background-image: url(" + resize(article.get('thumbnail_image'), { width: 500 }) + ")", true, true)) + " class=\"home-featured-cover-img\"></div><h4>" + (jade.escape(null == (jade_interp = article.get('thumbnail_title')) ? "" : jade_interp)) + "</h4><h5>" + (jade.escape(null == (jade_interp = article.byline()) ? "" : jade_interp)) + "</h5></a></li>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var article = $$obj[i];

buf.push("<li class=\"home-featured-article-link\"><a" + (jade.attr("href", article.href(), true, true)) + "><div" + (jade.attr("style", "background-image: url(" + resize(article.get('thumbnail_image'), { width: 500 }) + ")", true, true)) + " class=\"home-featured-cover-img\"></div><h4>" + (jade.escape(null == (jade_interp = article.get('thumbnail_title')) ? "" : jade_interp)) + "</h4><h5>" + (jade.escape(null == (jade_interp = article.byline()) ? "" : jade_interp)) + "</h5></a></li>");
    }

  }
}).call(this);

buf.push("</ul></div>");
}}.call(this,"articles" in locals_for_with?locals_for_with.articles:typeof articles!=="undefined"?articles:undefined,"featuredArticles" in locals_for_with?locals_for_with.featuredArticles:typeof featuredArticles!=="undefined"?featuredArticles:undefined,"resize" in locals_for_with?locals_for_with.resize:typeof resize!=="undefined"?resize:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;